import axios from '../common/axios';

// 老师后台获取 APP 资讯列表
export const getNewsList = ({ page, pageSize, typeId, status, publishTimeRange }) =>
  axios.get('/app/news/consultant/list', {
    page,
    pageSize,
    typeId,
    status,
    publishTimeRange: publishTimeRange?.length > 1 ? JSON.stringify(publishTimeRange) : [],
  });

// 老师后台获取 APP 资讯详情
export const getNewsDetail = id => axios.get('/app/news/consultant/item', { id });

// 老师后台创建 APP 资讯
export const createNews = ({ title, coverUrl, content, typeId, schoolIds = [] }) =>
  axios.post('/app/news/consultant/item', { title, coverUrl, content, typeId, schoolIds });

//   师后台编辑 APP 资讯
export const editNews = ({ id, title, coverUrl, content, typeId, schoolIds = [] }) =>
  axios.put('/app/news/consultant/item', { id, title, coverUrl, content, typeId, schoolIds });

// 老师后台 APP 资讯提交审核
export const submitNews = id => axios.post(`/app/news/consultant/item/submit?id=${id}`);

// 老师后台 APP 资讯撤回
export const revokeNews = id => axios.post(`/app/news/consultant/item/revoke?id=${id}`);

// 老师后台 APP 资讯删除
export const deleteNews = id => axios.delete(`/app/news/consultant/item?id=${id}`);

//  获取 APP 资讯选项数据
export const getOptions = () => axios.get('/app/news/consultant/options');
